export default {
    title: "Lar",
    button: {
        accessories: "Navegar no catálogo"
    },
    noAvailableItems: "O Portal Periférico não tem nenhum item disponível para o seu país no momento. Por favor, trabalhe com seu gerente para adquirir os itens que você precisa.<br><br> <a href='#' role='button' data-widget-trigger='{widgetOptions}'>Entre em contato com o suporte</a>",
    error: "Ocorreu um problema ao recuperar os produtos. Atualize seu navegador."
}